import { commaSeperate } from "@app/helpers/number-helper.ts";

export function formatUsd(amount?: number): string {
    if (amount == undefined) {
        return "$0.00";
    }

    const rawString = amount.toFixed(2).toString();
    const commaSeperated = commaSeperate(rawString);
    return `$${commaSeperated}`;
}
